<div class="users-management-content">
  <!-- Header -->
  <div class="header">
    <div class="button-icon button-back" (click)="back()">
      <mat-icon svgIcon="arrow-left" class="icon"></mat-icon>
    </div>
    <div class="title">
      <div class="meta">
        @if (project) {
          <div class="project-name">{{ project.name }}</div>
        }
        @if (record?.id) {
          <div class="record-id"
               matTooltip="Copy record id"
               [matTooltipShowDelay]="1000"
               (click)="copyRecordId()">{{ record?.id }}</div>
        }
      </div>
      <div class="name">{{ record?.title }}</div>
      @if (record?.status) {
        <div class="record-status" [matMenuTriggerFor]="statusMenu" [ngClass]="record?.status">{{ record?.status }}</div>
        <mat-menu #statusMenu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="changeStatus('scheduled')">scheduled</button>
            <button mat-menu-item (click)="changeStatus('preparing')">preparing</button>
            <button mat-menu-item (click)="changeStatus('inprogress')">inprogress</button>
            <button mat-menu-item (click)="changeStatus('finished')">finished</button>
            <button mat-menu-item (click)="changeStatus('canceled')">canceled</button>
            <button mat-menu-item (click)="changeStatus('error')">error</button>
          </ng-template>
        </mat-menu>
      }

    </div>
    <div class="button-actions">
      @if (permissions | includesBy: 'record:create') {
        <div class="button secondary" (click)="duplicateRecord()">Duplicate</div>
      }
      @if (record?.status === 'scheduled' && (permissions | includesBy: 'record:update')) {
        <div class="button cancel" (click)="cancelRecord()">Cancel</div>
      }
      @if (record?.status === 'canceled' && (permissions | includesBy: 'record:update')) {
        <div class="button" [class.disabled]="!canRestoreRecord" (click)="restoreRecord()">Restore</div>
      }
      @if ((permissions | includesBy: 'record:update')) {
        <div class="button secondary" (click)="finishRecord()">Finish</div>
      }
    </div>
  </div>
  <!-- Body -->
  <div class="records">

    <!-- Record -->
    @if (record) {
      <div class="record-details">

        <!-- Record Info (expandable) -->
        <div class="record-info-section" [class.expanded]="showInfo">
          <div class="section-header" (click)="showInfo = !showInfo">
            <mat-icon svgIcon="arrow-left" class="chevron" [class.expanded]="showInfo"></mat-icon>
            <div class="section-title">Record Info</div>
            @if (!showInfo) {
              <div class="summary">
                @if (record.status) {
                  <div class="record-status" [ngClass]="record.status">{{ record.status }}</div>
                }
                @if (record.startTime) {
                  <div class="summary-item">
                    <span class="summary-label">Start</span>
                    <span class="summary-value">{{ record.startTime | date:'MMM d, y · HH:mm' }}</span>
                  </div>
                }
                @if (project?.startTrigger?.type === 'startTime') {
                  <div class="summary-item">
                    <span class="summary-label">Duration</span>
                    <span class="summary-value">{{ getDurationLabel() }}</span>
                  </div>
                }
                @if ((record.servers?.length ?? 0) > 0) {
                  <div class="summary-item">
                    <span class="summary-label">Servers</span>
                    <span class="summary-value">{{ record.servers?.length }}</span>
                  </div>
                }
                @if (getMetadataCount() > 0) {
                  <div class="summary-item">
                    <span class="summary-label">Metadata</span>
                    <span class="summary-value">{{ getMetadataCount() }}</span>
                  </div>
                }
                @if (record.reference) {
                  <div class="summary-item">
                    <span class="summary-label">Ref</span>
                    <span class="summary-value">{{ record.reference }}</span>
                  </div>
                }
              </div>
            }
          </div>
          @if (showInfo) {
            <app-record-info
              [record]="record"
              [permissions]="permissions"
              [project]="project">
            </app-record-info>
          }
        </div>

        
        @for (server of record.servers; track server.id; let index = $index) {
          <div class="line">
            <!-- Server -->
            <div class="record-server">

              <div class="server-info">
                <!-- Cinedeck Agent -->
                <div class="info">
                  <div class="title">
                    <div class="online-status" [class.online]="server.isServerOnline"></div>
                    <div class="name">{{ server.name }}</div>
                    <div class="version">{{ server.type }}</div>
                  </div>
                  <div class="details">
                    <div class="address">{{ server.ip }}</div>
                  </div>
                </div>
                <!-- Cinedeck Server -->
                @if (server.channels?.length) {
                  <div class="info">
                    <div class="title">
                      <div class="online-status" [class.online]="server.isCinedeckOnline"></div>
                      <div class="name">Cinedeck Server</div>
                      <div class="version">{{ server.id }}</div>
                    </div>
                  </div>
                }

              </div>

              <div class="column">
                <!-- Formats -->
                @if (server.channels) {
                  <div class="inputs">
                    @for (channel of server.channels; track $index; let index = $index) {
                      <div class="channel">
                        <div class="name" [class.recording]="servers[server.id] && servers[server.id].recordStatus?.record?.record">{{ channel.format }}</div>
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="column">
                <!-- SRT Stats -->
                <app-srt-stats-popover [recordId]="record.id" [serverId]="server.id"></app-srt-stats-popover>
              </div>

              <!-- Tasks -->
              <div class="task-list">
                <app-tasks-board [record]="record" [server]="server"></app-tasks-board>
              </div>

              <!-- Server Actions -->
              @if (permissions | includesBy: 'record:update') {
                <div class="button-icon server-menu" [matMenuTriggerFor]="serverMenu">
                  <mat-icon svgIcon="dots" class="icon"></mat-icon>
                </div>
                <mat-menu #serverMenu="matMenu">
                  <ng-template matMenuContent>
                    <button mat-menu-item (click)="createTasks(server)">Create Tasks</button>
                    <button mat-menu-item (click)="recreateServerInstance(server)">Re-create AWS Server</button>
                    <button mat-menu-item (click)="reloadAgentData(server)">Reload Agent Data</button>
                    <button mat-menu-item (click)="restartAgent(server)">Restart Agent</button>
                  </ng-template>
                </mat-menu>
              }
            </div>

          </div>
        }

        <!-- Record -->
        @if (project?.startTrigger?.type === 'manual' && (record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress') && (permissions | includesBy: 'record:actions')) {
          <div class="record-actions-content">
            <!-- Record Actions -->
            @if ((record.servers?.length ?? 0) > 1) {
              <div class="record-actions-block">
                <div class="record-actions-title">ALL Servers Actions:</div>
                <div class="record-actions">
                  @if ((permissions | includesBy: 'record:actions')) {
                    <div class="button secondary cancel" (click)="startRecord()">Start Record</div>
                  }
                  @if ((permissions | includesBy: 'record:actions')) {
                    <div class="button secondary" (click)="stopRecord()">Stop Record</div>
                  }
                </div>
              </div>
            }
            <!-- Approve -->
            @if (actions.irisUpload.show || actions.irisOvertimeUpload.show) {
              <div class="record-actions-block">
                <div class="record-actions-title">Approve</div>
                <div class="record-actions">
                  @if (actions.irisUpload.show) {
                    <div class="button secondary secondary" [class.selected]="!actions.irisUpload.done" [class.disabled]="!actions.irisUpload.enabled || actions.irisUpload.done" (click)="approveRecord(false)">Main</div>
                  }
                  @if (actions.irisOvertimeUpload.show) {
                    <div class="button secondary secondary" [class.selected]="!actions.irisOvertimeUpload.done" [class.disabled]="!actions.irisOvertimeUpload.enabled || actions.irisOvertimeUpload.done" (click)="approveRecord(true)">Overtime</div>
                  }
                </div>
              </div>
            }
            <!-- Reset -->
             @if (actions.resetTasks.show || actions.resetOvertimeTasks.show) {
              <div class="record-actions-block">
                <div class="record-actions-title">Reset Program</div>
                <div class="record-actions">
                  @if (actions.resetTasks.show) {
                    <div class="button secondary secondary" (click)="resetRecordTasks(['main'])">Main</div>
                  }
                  @if (actions.resetOvertimeTasks.show) {
                    <div class="button secondary secondary" (click)="resetRecordTasks(['overtime'])">Overtime</div>
                  }
                </div>
              </div>
            }

          </div>
        }

        <!-- Preview and actions -->
         @if (display.preview) {
        <div class="record-preview">
          <!-- Tab -->
          <div class="preview-type">
            @for (server of record.servers; track server.id; let index = $index) {
              <div class="type" (click)="selectPreview('live', server.id)" [class.selected]="preview.type === 'live' && preview.serverId === server.id">
                {{ server.name }} Incoming Feed
              </div>
            }
            @for (server of record.servers; track server.id; let index = $index) {
              @if (!server?.settings?.playbackDisabled) {
                <div class="type" (click)="selectPreview('playback', server.id)" [class.selected]="preview.type === 'playback' && preview.serverId === server.id">
                  {{ server.name }} Playback
                </div>
              }
            }
          </div>

          <!-- Timecode -->
          <div class="timecode-content">
            <!-- CC -->
            <div class="button-cc" [class.enabled]="showCC" (click)="showCC = !showCC" [matTooltip]="ccType" [matTooltipShowDelay]="1000">
              <div>CC</div>
              <div #ccTypeMenuButton class="button-icon cc-menu" (click)="openCCTypeMenu($event)" [matMenuTriggerFor]="ccMenu">
                <mat-icon svgIcon="dots" class="icon"></mat-icon>
              </div>
              <mat-menu #ccMenu="matMenu">
                <ng-template matMenuContent>
                  <button mat-menu-item [class.menu-button-selected]="ccTypes.includes('cc1')" (click)="selectCCType('cc1')">CC1</button>
                  <button mat-menu-item [class.menu-button-selected]="ccTypes.includes('cc3')" (click)="selectCCType('cc3')">CC3</button>
                  <button mat-menu-item [class.menu-button-selected]="ccTypes.includes('service1')" (click)="selectCCType('service1')">Service1</button>
                  <button mat-menu-item [class.menu-button-selected]="ccTypes.includes('service2')" (click)="selectCCType('service2')">Service2</button>
                </ng-template>
              </mat-menu>
            </div>
            <!-- Timecode -->
            <div class="timecode" #timecode>00:00:00:00</div>
            <!-- Volume -->
            <div class="volume">
              <div class="volume-button" (click)="updateAudio()">
                <mat-icon [svgIcon]="audio.enable ? 'volume' : 'volume-mute'" class="icon"></mat-icon>
              </div>
              <mat-slider class="volume-slider" min="0" max="1" step="0.05" [class.disabled]="!audio.enable">
                <input matSliderThumb [value]="audio.volume" (valueChange)="updateVolume($event)">
              </mat-slider>
            </div>
          </div>

          <div class="preview-content">
            <!-- Preview -->
            <app-preview
              class="preview"
              [record]="record"
              [status]="preview.status"
              [channel]="preview.channel"
              [serverId]="preview.serverId"
              [audio]="audio.enable"
              [audioPair]="audio.pair"
              [volume]="audio.volume"
              (timecodeChanged)="setTimecodes($event)"
              (ccChanged)="setCC($event)"
              (audioLevels)="setAudioLevel($event)"
            ></app-preview>

            <!-- Audio levels -->
            <app-audio-levels
              class="audio-levels"
              [isPlayback]="preview.type === 'playback'"
              [selected]="audio.pair"
              (selectedChange)="changeAudioPair($event)"
            ></app-audio-levels>
          </div>

          <!-- CC -->
          @if (showCC) {
            @for (cc of ccTypes; track cc) {
              <app-preview-cc class="record-cc" [type]="cc"></app-preview-cc>
            }
          }

          <!-- S3 Download -->
          @if (preview.isS3Download && (permissions | includesBy: 'record:actions')) {
            <div class="record-actions">
              <div class="s3-download-content">
                <input class="input" [class.disabled]="preview.isS3DownloadInProgress" placeholder="Example: s3://bucket" [(ngModel)]="s3DownloadUrl">
                <div class="button secondary" [class.disabled]="preview.isS3DownloadInProgress" (click)="s3DownloadFile()">{{ preview.isS3DownloadInProgress ? 'Downloading' : 'Download' }}</div>
              </div>
            </div>
          }
  
          <!-- Record -->
          @if (project?.startTrigger?.type === 'manual' && preview.type === 'live') {
            <div class="record-actions">
              @if ((record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress') && !preview.status?.record?.record && (permissions | includesBy: 'record:actions')) {
                <div class="button secondary cancel" (click)="startRecord(preview.serverId)">
                  Start Record
                  <div class="button-icon" [matMenuTriggerFor]="recordMenu" (click)="$event.stopPropagation()">
                    <mat-icon svgIcon="dots" class="icon"></mat-icon>
                  </div>
                  <mat-menu #recordMenu="matMenu">
                    <ng-template matMenuContent>
                      <button mat-menu-item (click)="startTestRecord(preview, $event)">Start Test Record</button>
                    </ng-template>
                  </mat-menu>
                </div>
              }
              @if (preview.status?.record?.record && (permissions | includesBy: 'record:actions')) {
                <div class="button secondary" (click)="resetRecord(preview.serverId)">Reset Record</div>
                <div class="button secondary" (click)="stopRecord(preview.serverId)">Stop Record</div>
              }
            </div>
          }

          <!-- Playback -->
          @if (preview.type === 'playback') {
            <div class="playback-actions">
              <!-- Progress bar -->
              <app-playback-progress-bar
                class="playback-progress-bar"
                [class.disabled]="!(permissions | includesBy: 'record:actions')"
                [record]="record"
                [clip]="preview.clip"
                [serverId]="preview.serverId"
              ></app-playback-progress-bar>
  
              <!-- Actions -->
              <app-playback-actions
                class="playback-actions"
                [class.disabled]="!(permissions | includesBy: 'record:actions')"
                [record]="record"
                [clip]="preview.clip"
                [status]="preview.status"
                [serverId]="preview.serverId"
              ></app-playback-actions>
  
              @if (permissions | includesBy: 'record:actions') {
                <!-- Points -->
                <div class="playback-points">

                  <!-- iCap In/Out Points -->
                  @if (preview.isICap) {
                    <app-transcode-in-out-points class="playback-in-out-points" title="Transcode" [record]="record" [clip]="preview.clip" [serverId]="preview.serverId"></app-transcode-in-out-points>
                  }
  
                  <!-- In/Out Points -->
                  @if (preview.isTrim) {
                    <app-playback-in-out-points class="playback-in-out-points" title="Main Program" [record]="record" [clip]="preview.clip" [serverId]="preview.serverId"></app-playback-in-out-points>
                  }
                  
                  <!-- Manual Upload -->
                  @if (preview.isManualUpload) {
                    <app-record-manual-upload [record]="record" [serverId]="preview.serverId"></app-record-manual-upload>
                  }
  
                  <!-- In/Out Overtime Points -->
                  @if (preview.isOvertimeTrim) {
                    <app-playback-in-out-points class="playback-start-end-points" title="Overtime" [record]="record" [clip]="preview.clip" [serverId]="preview.serverId" [overtime]="true"></app-playback-in-out-points>
                  }
  
                </div>
              }
            </div>
          }

        </div>
        } @else if (display.s3DownloadInput && (permissions | includesBy: 'record:actions')) {
          <div class="record-actions">
            <div class="s3-download-content">
              <input class="input" [class.disabled]="false" placeholder="Example: s3://bucket" [(ngModel)]="s3DownloadUrl">
              <div class="button secondary" [class.disabled]="false" (click)="s3DownloadFile()">{{ 'Download' }}</div>
            </div>
          </div>
        }

        <!-- Logs -->
        <div class="record-logs">
          <div class="title">Events:</div>
          <div class="search">
            <input class="input" placeholder="Search..." [(ngModel)]="search.text" (ngModelChange)="filterRecordEvents()">
            <div class="search-actions">
              <div class="button secondary">Search</div>
              @for (server of record.servers; track server.id; let index = $index) {
                <div class="button server" [class.secondary]="search.serverId !== server.id" (click)="filterRecordEventsByServerId(server.id)">{{ server.name }}</div>
              }
            </div>
          </div>
          <div class="logs">
            @for (event of displayRecordEvents; track event.id; let index = $index) {
              <div class="record-event" [ngClass]="event.level">
                <div class="date">{{ event.createdAt | date: 'medium' }}</div>
                @if (event.recordServerId) {
                  <div class="owner" [ngClass]="getServerType(event.recordServerId)">{{ getServerName(event.recordServerId) }}</div>
                }
                @if (event.source) {
                  <div class="source" [ngClass]="event.source">{{ getEventSource(event) | titlecase }}</div>
                }
                @if (event.level !== 'info') {
                  <div class="level" [ngClass]="event.level">{{ event.level | uppercase }}</div>
                }
                <div class="text" [innerHTML]="event.text | highlightSearch: search.text"></div>
              </div>
            }
          </div>
        </div>

      </div>
    }


  </div>
</div>
